import React, {useState, useEffect, useCallback, useMemo} from 'react';
import get from 'lodash/get';
import {init, register, unregister} from '@dnd-it/dnd-iframe-messaging/parent';

import {getAspectRatio, createDataWrapperListener} from '~/src/utilities/helpers/embed';

import css from './EmbedIframe.module.scss';
import {classNames} from '~/src/utilities/helpers/css';

if (process.browser) {
    init();
}

const useResponsiveEmbed = (props) => {
    const [data, setData] = useState({});
    const [styles, setStyles] = useState(() => {
        if (props.url.indexOf('https://static-raetsel.ateleris.com') !== -1) {
            return {};
        }

        const height = get(props, 'options.height.desktop');
        if (height) {
            return {height: `${height}px`};
        }

        const aspectRatio = getAspectRatio(props.embedCode);
        return {paddingBottom: `${100 / aspectRatio}%`};
    });

    const classnames = useMemo(() => {
        if (props.url.indexOf('https://static-raetsel.ateleris.com') !== -1) {
            return {
                sudoku: props.url.indexOf('sudoku') !== -1,
                crosswords: props.url.indexOf('crosswords') !== -1
            };
        }

        return {};
    });

    const onLoad = useCallback(
        (event) => {
            const iframe = event.target;
            // datawrapper
            if (iframe.src.indexOf('datawrapper.dwcdn.net') !== -1) {
                const listener = createDataWrapperListener(iframe.src, setStyles);
                window.addEventListener('message', listener);

                setData({
                    type: 'dataWrapper',
                    listener
                });

                return;
            }

            setData({
                type: 'autofit',
                id: register(
                    {
                        autofit: ({contentHeight}) => {
                            setStyles({height: contentHeight});
                        }
                    },
                    (id) => {
                        iframe.contentWindow.postMessage({type: 'setAutofit', iframeId: id}, '*'); // legacy support
                        iframe.contentWindow.postMessage({type: 'setup', id}, '*');
                    }
                )
            });
        },
        [props.url]
    );

    useEffect(
        () => () => {
            switch (data.type) {
                case 'dataWrapper':
                    window.removeEventListener('message', data.listener);
                    break;
                case 'autofit':
                    unregister(data.id);
                    break;
                default:
                    break;
            }
        },
        [data]
    );

    return {
        styles,
        classnames,
        onLoad
    };
};

const EmbedIframe = (props) => {
    const {styles, classnames, onLoad} = useResponsiveEmbed(props);
    const [isReady, setReady] = useState(false);

    const containerClasses = classNames(css, 'container', classnames);

    useEffect(() => {
        setReady(process.browser);
    });

    return (
        <div className={containerClasses} style={styles} data-testid="EmbedIframe">
            {isReady && <iframe className={css.content} src={props.url} scrolling="no" frameBorder="no" allow="autoplay" allowFullScreen onLoad={onLoad} />}
        </div>
    );
};

export default EmbedIframe;
